var map = {
	"./black/zhuanjie2.png": "ANxa",
	"./blue/zhuanjie2.png": "WhCN",
	"./white/zhuanjie2.png": "uPJG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TgNb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/zhuanjie2\.png$
// module id = TgNb
// module chunks = 24